import Navbar from "../components/Navbar/Navbar.jsx";
import Hero from "../components/Hero/Hero.jsx";
import Hero2 from "../components/Hero/Hero2.jsx";
import Clients from "../components/Clients/Clients.jsx";
import HowItWorks from "../components/HowItWorks/HowItWorks.jsx";
import About from "../components/About/About.jsx";
import FAQs from "../components/Faq/FAQs.jsx";
import Started from "../components/Started/Started.jsx";
import Footer from "../components/Footer/Footer.jsx";
import { useParams } from "react-router-dom";
import React, { useState } from "react";
import { homeContent } from "../content.js";
import ArticleList from "../components/ArticleList/ArticleList.jsx";

function App() {
  const { step } = useParams();

  const renderHero = () => {
    if (step === "signup") {
      return <Hero2 />;
    }
    return <Hero />;
  };

  return (
    <div>
      <Navbar list={[{ text: homeContent.how, id: "#howItWorks" }, { text: homeContent.dataProtection, id: "#about" }, { text: homeContent.faq, id: "#faqs" }]} />
      <main>
        <div id="navbar"></div>
        {renderHero()}
        <Clients />
        <HowItWorks />
        <About />
        <FAQs />
        <ArticleList />
        <Started text={homeContent.started} />
      </main>
      <Footer showLogo={true} />
    </div>
  );
}

export default App;

